import React from 'react'
import { Document } from '../landingpage/components/document';
import { Footer } from '../landingpage/components/footer';
import { ScrollableTable, tableColumn } from '../chatbot/components/scrollableTable';
import { TokenPrices } from '../chatbot/api/llmapi';
import { Conversation } from '../fasades/conversation';
import { Util } from '../fasades/util';

interface IPricingState {
    prices: TokenPrices;
}

export class Pricing extends React.Component {

    state: IPricingState = {
        prices: {
            inputTokenPrice: "0.00",
            outputTokenPrice: "0.00",
            trainTokenPrice: "0.00"
        }
    };

    private columns: tableColumn[] = [
        { label: "Training Tokens", key: "trainTokenPrice" },
        { label: "Inference Input Tokens", key: "inputTokenPrice" },
        { label: "Inference Output Tokens", key: "outputTokenPrice" },
    ];

    componentDidMount(): void {
        if (Util.isPrerendering()) {
            return;
        }

        Conversation.fetchTokenPricing().then((data) => { this.setState({prices: data}); });
    }

    render() {
        const data = [this.state.prices];
        return (
            <>
            <title>Pricing - TigerCity AI</title>
            <div className="scroll">
                    <div className="document-view">
                        <Document classes="main">
                            <h1>Pricing</h1>
                            <p>This page provides the detailed pricing information for TigerCity AI's features. All prices are in USD</p>
                            <br/>
                            <ScrollableTable columns={this.columns} tableData={data} />
                            
                        </Document>
                    </div>
                    <Footer/>
                </div>
            </>
        )
    }
}
